import React, { useState } from 'react';
import '../App.css';
import Modal from './Modal';

const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  /* const [showGithub, setShowGithub] = useState(false); */

  return (
    <footer className="footer bg-gray-900 text-gray-200 py-4 mt-8">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p className="text-sm">&copy; {new Date().getFullYear()} Global Savings Pools.<br />All Rights Reserved.</p>
        <p className="text-sm">🏦 Built with Trust. Powered by Blockchain.</p>
        <div className="footer-links mt-2">
          <button className="btn-footer" onClick={() => setShowTerms(true)}>Terms of Service</button>
          <button className="btn-footer" onClick={() => setShowPrivacy(true)}>Privacy Policy</button>
          {/* <button className="btn-footer" onClick={() => setShowGithub(true)}>GitHub</button> */}
        </div>

        <Modal isOpen={showTerms} onClose={() => setShowTerms(false)}>
          <h2 className="font-bold mb-2">Terms of Service</h2>
          <p>
            These Terms of Service outline your responsibilities and usage guidelines. Global Savings Pools is not operated by any company and is fully automated through blockchain technology.
          </p>
          <button className="btn-primary px-4 py-2" onClick={() => setShowTerms(false)}>
              Close
            </button>
        </Modal>

        <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)}>
          <h2 className="font-bold mb-2">Privacy Policy</h2>
          <p>
            We respect your privacy. No personal data is collected or stored by Global Savings Pools. All operations are blockchain-based and automated.
          </p>
          <button className="btn-primary px-4 py-2" onClick={() => setShowPrivacy(false)}>
              Close
            </button>
        </Modal>

        {/* <Modal isOpen={showGithub} onClose={() => setShowGithub(false)}>
          <h2 className="font-bold mb-2">GitHub Repository</h2>
          <p>
            Visit our GitHub repository: <a href="https://github.com/soon" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-500">https://github.com/tbd</a>
          </p>
        </Modal> */}
      </div>
    </footer>
  );
};

export default Footer;